export default "__VITE_ASSET__nqVdRKFT__"